import React from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ListingCard from '../Components/ListingCard';
import { EXLY_WEBPAGE_DETAILS__SET_KEYWORDS, EXLY_WEBPAGE_DETAILS__SET_LISTINGS, EXLY_WEBPAGE_DETAILS__SET_PREPEND_PLAN } from 'ui/pages/TemplatePreview/redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { is_empty } from 'utils/validations';
import AccordianCard from '../Components/AccordianCard';
import { Checkbox } from '@material-ui/core';
import module_style from "../Style.module.css";
import UpdateName from '../Modals/UpdateName';
import RenderKeywordPlans from './RenderKeywordPlans';
import dataProvider from 'data/dataProvider';
import api from 'data/APIs';
import { WebpageCreationContext } from 'ui/pages/TemplatePreview';

const form_data = {
    unassigned: 'unassigned',
    listings: 'listings',
    plans: 'plans',
    SKU: 'SKU',
    LISTING: 'LISTING',
    PLAN: 'PLAN',
    KEYWORD: 'KEYWORD'
}

const Plan = ({ order_by_keyword }) => {
    const dispatch = useDispatch();
    const listings_data = useSelector((state) => state.webpage_detail.listings);
    const keywords = useSelector((state) => state.webpage_detail.keywords);

    const [prepend_plans, set_prepend_plans] = React.useState(listings_data?.prepend_plans)
    const [edit_plan_heading, set_edit_plan_heading] = React.useState(false);
    const [data, set_data] = React.useState(null);

    React.useEffect(() => {
        create_data();
    }, [order_by_keyword, edit_plan_heading, keywords]);

    const {
        pushNotif,
    } = React.useContext(WebpageCreationContext);

    const create_data = () => {
        if (order_by_keyword) {
            let plan_keywords = keywords.map((item) => {
                let keywords_plans = listings_data.plans_data?.plans?.filter((plan) => {
                    if (is_empty(plan.tag)) {
                        return false;
                    }
                    if (plan.tag.includes(item.keyword)) return true;
                });
                return ({
                    title: item.keyword,
                    id: `plan_keyword_${item.uuid}`,
                    plans: keywords_plans
                })
            })
            return set_data(plan_keywords);
        }

    }

    const renderPlans = () => {
        return (
            <>
                {listings_data.plans_data?.plans?.map((item, index) => {
                    return (
                        <Draggable
                            key={`plans-${index}`}
                            draggableId={`plans-${index}`}
                            index={index}
                        >
                            {(provided) => (
                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={`col-12 bottom_margin`}>
                                    <ListingCard item={item} index={index} provided={provided} />
                                </div>
                            )}
                        </Draggable>
                    )
                })}
            </>
        )
    }

    const handleKeywordPlanDrag = (result, keyword) => {
        let output = listings_data;
        let plans = listings_data.plans_data.plans;
        let plan_listings = keyword === form_data.unassigned ? plans.filter((plan) => is_empty(plan.tag)) : plans.filter((plan) => plan.tag.includes(keyword));
        const reordered_plan_listings = plan_listings.splice(result.source.index, 1);
        plan_listings.splice(result.destination.index, 0, ...reordered_plan_listings);
        for (let i = 0; i < plan_listings.length; i++) {
            let item = plan_listings[i];
            item.priority = plan_listings.length - i;
            plans.filter((plan, index) => {
                if (plan.plan_uuid === item.plan_uuid) {
                    plans.splice(index, 1);
                }
            })
        }
        plans.splice(plans.length, 0, ...plan_listings);
        output.plans_data.plans = plans;
        dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_LISTINGS, payload: output });
    }

    const removeKeyword = (item, result) => {
        try {
            if (!is_empty(item) && !is_empty(item?.keyword_uuid)) {
                let keyword = item.keyword_uuid === form_data.unassigned ? item.keyword_uuid : keywords.filter((value) => value.uuid === item.keyword_uuid)[0].keyword;
                let output = listings_data;
                let plans = listings_data.plans_data.plans;
                let plan_listings = keyword === form_data.unassigned ? plans.filter((plan) => is_empty(plan.tag)) : plans.filter((plan) => plan.tag.includes(keyword));
                let removed_listing = plan_listings.splice(result.source.index, 1)[0];
                if (is_empty(removed_listing)) return;
                for (let i = 0; i < plan_listings.length; i++) {
                    let item = plan_listings[i];
                    item.priority = plan_listings.length - i;
                    plans.filter((plan, index) => {
                        if (plan.plan_uuid === item.plan_uuid) {
                            plans.splice(index, 1);
                        }
                    })
                }
                if (keyword !== form_data.unassigned) {
                    for (let plan of plans) {
                        if (plan.plan_uuid === removed_listing.plan_uuid) {
                            plan.tag.splice(plan.tag.indexOf(keyword), 1);
                        }
                    }
                }
                plans.splice(plans.length, 0, ...plan_listings);
                output.plans_data.plans = plans;
                dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_LISTINGS, payload: output });


                if (keyword !== form_data.unassigned) {
                    removed_listing.tag.splice(removed_listing.tag.indexOf(keyword), 1);
                    dataProvider.custom_request(api.remove_keyword_plan, 'POST', { "keyword_uuid": item.keyword_uuid, "entity_uuid": item.listing_id ? item.listing_id : item.plan_uuid });
                }
                return removed_listing;
            }
        }
        catch (err) {
            console.log('removeKeyword err', err);
            throw err;
        }
    }

    const addKeyword = (item, result) => {
        try {
            let keyword = item.keyword_uuid === form_data.unassigned ? item.keyword_uuid : keywords.filter((value) => value.uuid === item.keyword_uuid)[0].keyword;
            let output = listings_data;
            let plans = listings_data.plans_data.plans;
            const removed_listing = item.removed_listing;
            let plan_listings = keyword === form_data.unassigned ? plans.filter((plan) => is_empty(plan.tag) && plan.plan_uuid != removed_listing.plan_uuid) : plans.filter((plan) => plan.tag.includes(keyword) && plan.plan_uuid != removed_listing.plan_uuid);
            plan_listings.splice(result.destination.index, 0, removed_listing);
            for (let i = 0; i < plan_listings.length; i++) {
                let item = plan_listings[i];
                item.priority = plan_listings.length - i;
                plans.filter((plan, index) => {
                    if (plan.plan_uuid === item.plan_uuid) {
                        if (keyword !== form_data.unassigned) plan.tag.push(keyword)
                        plans.splice(index, 1);
                    }
                })
            }
            plans.splice(plans.length, 0, ...plan_listings);
            output.plans_data.plans = plans;
            dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_LISTINGS, payload: output });


            if (keyword !== form_data.unassigned) dataProvider.custom_request(api.add_keyword_plans, 'POST', { "keyword_uuid": item.keyword_uuid, "entity_uuid": [item.plan_uuid] });
        }
        catch (err) {
            console.log('handleAdd err', err);
            throw err;
        }
    }

    const handleCrossKeywordListingDrag = async (result) => {
        try {
            let removed_listing;
            let source = result.source.droppableId.split(`_keyword_`);
            let destination = result.destination.droppableId.split(`_keyword_`);
            removed_listing = removeKeyword({ keyword_uuid: source[1], plan_uuid: result.draggableId }, result);
            if (is_empty(removed_listing)) return;
            addKeyword({ keyword_uuid: destination[1], plan_uuid: result.draggableId, removed_listing }, result);
        }
        catch (err) {
            console.log('handleCrossKeywordListingDrag err', err);
            pushNotif(err?.body?.message ? err?.body?.message : 'Something went wrong');
        }
    }

    const handlePlanDrag = (result) => {
        let plans = listings_data.plans_data.plans;
        const reorderedPlans = plans.splice(result.source.index, 1);
        plans.splice(result.destination.index, 0, ...reorderedPlans);
        for (let i = 0; i < plans.length; i++) {
            let item = plans[i];
            item.priority = plans.length - i;
        }
        let output = listings_data;
        output.plans_data.plans = plans;
        dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_LISTINGS, payload: output });
    }

    const handleOnDragEnd = (result) => {
        console.log('result', result);
        if (is_empty(result.destination) || (result.destination.droppableId === result.source.droppableId && result.destination.index === result.source.index)) {
            return;
        }

        if (result.type === form_data.KEYWORD) {
            let output = keywords;
            const reorderedKeyword = output.splice(result.source.index, 1);
            output.splice(result.destination.index, 0, ...reorderedKeyword);

            for (let i = 0; i < output.length; i++) {
                let item = output[i];
                item.sequence = i + 1;
            }
            console.log(output);
            dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_KEYWORDS, payload: output });
        }

        else if (result.type === form_data.PLAN) {
            if (result.source.droppableId.includes('keyword')) { // check if keyword based
                let source = result.source.droppableId.split(`_keyword_`);
                let destination = result.destination.droppableId.split(`_keyword_`);
                if (source[1] == destination[1]) {// check if intra keyword
                    if (source[1] == form_data.unassigned) { // if intra unassigned plans
                        handleKeywordPlanDrag(result, form_data.unassigned);
                    }
                    else {
                        let keyword = keywords.filter((item) => item.uuid === source[1])[0].keyword;
                        handleKeywordPlanDrag(result, keyword);
                    }
                }
                if (source[1] != destination[1]) {
                    handleCrossKeywordListingDrag(result)
                }
            }
        }
        else { // normal intra plan
            handlePlanDrag(result);
        }

        create_data();
    }

    return (
        <div className={`mt-4`}>
            {!is_empty(listings_data) && <AccordianCard handleEdit={() => {
                set_edit_plan_heading(true)
            }} title={listings_data.plans_data.title} >
                <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="plans" type="PLANS" mode="standard">
                        {(provided) => {
                            return (
                                <div
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {order_by_keyword && !is_empty(data) ? <RenderKeywordPlans data={data} /> : renderPlans()}

                                    {provided.placeholder}
                                </div>
                            );
                        }}
                    </Droppable>
                </DragDropContext>

                <div className={`mt-3 row no-gutters`} style={{ alignItems: 'center' }}>
                    <Checkbox color='primary' checked={prepend_plans} onChange={(e) => {
                        let checked = e.target.checked;
                        set_prepend_plans(checked)
                        dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_PREPEND_PLAN, payload: checked })
                    }} />
                    <div className={`${module_style.sub_heading} ml-2`}>Place plans above listings?</div>
                </div>
            </AccordianCard>}
            {edit_plan_heading && <UpdateName type={'plan'} showModal={(value) => set_edit_plan_heading(value)} />}
        </div>
    )
}

export default Plan;